module.exports = __webpack_public_path__ + "img/-LV0qfJXE7bYVVGnIHZD.640099b7.jpg";